import { css } from 'styled-components';

export const typography = {
  elephant: css`
    font-size: 40px;
    line-height: 48px;
  `,
  rhino: css`
    font-size: 36px;
    line-height: 44px;
  `,
  tiger: css`
    font-size: 28px;
    line-height: 36px;
  `,
  chimp: css`
    font-size: 22px;
    line-height: 32px;
  `,
  coyote: css`
    font-size: 20px;
    line-height: 32px;
  `,
  dingo: css`
    font-size: 18px;
    line-height: 24px;
  `,
  emu: css`
    font-size: 16px;
    line-height: 24px;
  `,
  koala: css`
    font-size: 14px;
    line-height: 20px;
  `,
  quokka: css`
    font-size: 12px;
    line-height: 16px;
  `,
  quoll: css`
    font-size: 10px;
    line-height: 16px;
  `,
};

export const fontWeight = {
  light: 220,
  regular: 340,
  medium: 420,
  semibold: 500,
  bold: 620,
};

export const fontSize = {
  f75: css`
    font-size: 0.75rem;
  `,
  f87: css`
    font-size: 0.875rem;
  `,
  f100: css`
    font-size: 1rem;
  `,
  f125: css`
    font-size: 1.25rem;
  `,
  f150: css`
    font-size: 1.5rem;
  `,
  f175: css`
    font-size: 1.75rem;
  `,
  f200: css`
    font-size: 2rem;
  `,
  f250: css`
    font-size: 2.5rem;
  `,
  f300: css`
    font-size: 3rem;
  `,
};

export const lineHeight = {
  l100: css`
    line-height: 1rem;
  `,
  l200: css`
    line-height: 1.25rem;
  `,
  l300: css`
    line-height: 1.5rem;
  `,
  l400: css`
    line-height: 1.75rem;
  `,
  l500: css`
    line-height: 2rem;
  `,
  l600: css`
    line-height: 2.5rem;
  `,
  l700: css`
    line-height: 3.25rem;
  `,
  l800: css`
    line-height: 4rem;
  `,
  l900: css`
    line-height: 5rem;
  `,
  l1000: css`
    line-height: 6.5rem;
  `,
};

export const lsegLineHeights = {
  medium: css`
    line-height: 112.5%;
  `,
  large: css`
    line-height: 150%;
  `,
};

export const typographyV2 = {
  title3XL: css`
    ${fontSize.f300};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  title2XL: css`
    ${fontSize.f250};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleXL: css`
    ${fontSize.f200};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleLg: css`
    ${fontSize.f175};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleMd: css`
    ${fontSize.f150};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleBase: css`
    ${fontSize.f125};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleSm: css`
    ${fontSize.f100};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  titleXs: css`
    ${fontSize.f100};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,

  bodyMd: css`
    ${fontSize.f100};
    ${lsegLineHeights.large};
    font-weight: ${fontWeight.regular};
  `,
  bodyBase: css`
    ${fontSize.f100};
    ${lsegLineHeights.large};
    font-weight: ${fontWeight.regular};
  `,
  bodySm: css`
    ${fontSize.f87};
    ${lsegLineHeights.large};
    font-weight: ${fontWeight.regular};
  `,
  bodyXs: css`
    ${fontSize.f75};
    ${lsegLineHeights.large};
    font-weight: ${fontWeight.regular};
  `,

  uiBase: css`
    ${fontSize.f100};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  uiSm: css`
    ${fontSize.f87};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
  uiXs: css`
    ${fontSize.f75};
    ${lsegLineHeights.medium};
    font-weight: ${fontWeight.medium};
  `,
};
